import { jsx } from "react/jsx-runtime";
import EmptyConfigSearch from "./components/EmptyConfigSearch.js";
import EmptySearch from "./components/EmptySearch.js";
import NoData from "./components/NoData.js";
import NoMedia from "./components/NoMedia.js";
import NoMessage from "./components/NoMessage.js";
import NoPermission from "./components/NoPermission.js";
import NoTask from "./components/NoTask.js";
import PreviewEmpty from "./components/PreviewEmpty.js";
import UnarrivedTime from "./components/UnarrivedTime.js";
const rootClass = 'weet-components-empty';
const defaultDescription = "\u6682\u65E0\u6570\u636E";
const defaultEmptyImg = /*#__PURE__*/ jsx(NoData, {});
const emptySearch = /*#__PURE__*/ jsx(EmptySearch, {});
const noMedia = /*#__PURE__*/ jsx(NoMedia, {});
const noMessage = /*#__PURE__*/ jsx(NoMessage, {});
const noPermission = /*#__PURE__*/ jsx(NoPermission, {});
const previewEmpty = /*#__PURE__*/ jsx(PreviewEmpty, {});
const unarrivedTime = /*#__PURE__*/ jsx(UnarrivedTime, {});
const noTask = /*#__PURE__*/ jsx(NoTask, {});
const emptyConfigSearch = /*#__PURE__*/ jsx(EmptyConfigSearch, {});
const ImageSizeMap = {
    small: 80,
    middle: 120,
    large: 160
};
export { ImageSizeMap, defaultDescription, defaultEmptyImg, emptyConfigSearch, emptySearch, noMedia, noMessage, noPermission, noTask, previewEmpty, rootClass, unarrivedTime };
